module.exports = __webpack_public_path__ + "media/images/sankro-481a7e5c72edd55ef13c0ec4d5a0846a.jpeg";